import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { StyledContainer } from '../Heading/Heading.styles';
import media from '../../styles/config/mediaQueries';

const StyledSection = styled.section`
  padding: 32px 0 22px;
  border-bottom: 1px solid ${rgba(theme.color.white, 0.1)};
  ${media.mobile`
    ${StyledContainer} {
      margin-bottom: 27px;
    }
  `}
  ${media.desktop`
    ${StyledContainer} {
      margin-bottom: 0;
    }
  `}
`;

const StyledHeadingWrap = styled.div`
  ${media.desktop`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  `}
`;

const StyledCategoryHeading = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const StyledCircle = styled.span`
  width: 6px;
  height: 6px;
  margin-right: 6px;
  background-color: ${props => theme.color[props.color]};
  border-radius: 50%;
`;

const StyledCategoryName = styled.h4`
  ${typeStyle.h4}
  font-weight: 600;
`;

const StyledSponsorCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  min-height: 48px;

  svg {
    width: 23px;
    height: 23px;
  }

  ${media.desktop`
    margin-left: 10px;
  `}
`;

const StyledSponsorImg = styled.img`
  max-width: 72px;
  height: 40px;
  ${media.desktop`
    margin-right: 210px;
  `}
`;

const StyledSponsorLinks = styled.span`
  display: flex;
  align-items: center;
`;

const StyledSponsorLink = styled.a`
  display: flex;
  align-items: center;
  padding: 4.5px 0;

  &:first-of-type {
    border-right: 1px solid ${rgba(theme.color.white, 0.2)};
  }
  &:last-of-type {
    margin-left: 18px;
  }

  svg {
    margin-right: 8px;
  }
`;

const StyledList = styled.ul`
  margin: 0;
  padding: 0;
  ${media.desktop`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  `}
`;

const StyledListItem = styled.li`
  display: flex;
  min-height: 60px;
  list-style-type: none;
  ${media.desktop`
    flex: 1 1 calc(50% - 45px);
    break-inside: avoid-column;
    &:nth-child(even) {
      margin-left: 90px;
    }
  `}
`;

const StyledLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const StyledLinkContent = styled.span`
  display: flex;
  align-items: center;

  svg {
    width: 14px;
  }
`;

const StyledAppIcon = styled.img`
  width: 25px;
  max-height: 35px;
  margin-right: 11px;
`;

const StyledAppName = styled.h5`
  font-weight: 400;
  ${typeStyle['font-14']}
`;

const StyledLinkTitle = styled.span`
  margin-right: 15px;
  ${typeStyle['font-12']}
`;

export {
  StyledSection,
  StyledHeadingWrap,
  StyledCategoryHeading,
  StyledCircle,
  StyledCategoryName,
  StyledList,
  StyledListItem,
  StyledLink,
  StyledLinkContent,
  StyledAppIcon,
  StyledAppName,
  StyledLinkTitle,
  StyledSponsorCont,
  StyledSponsorImg,
  StyledSponsorLinks,
  StyledSponsorLink,
};
